<script>
  import { Modal, TextInput } from "carbon-components-svelte";
  import ButtonColorSelector from "../analysis/components/ButtonColorSelector.svelte";

  export let color = getRandomColor();
  export let analysisid;
  export let editActivityName = "";
  export let editActivityColor = color;
  export let startEvents = [];
  export let endEvents = [];
  export let windowTitles = [];
  export let modalOpen = false;
  export let editActivityId = "";
  export let updateActivity = () => {};
  export let saveActivity = () => {};
  export let primaryWindows = [];

  let listOfColors = [
    { name: "green", value: "#93EDA3" },
    { name: "red", value: "#F86353" },
    { name: "yellow", value: "#FBF26C" },
    { name: "blue", value: "#99C1F2" },
  ];

  function getRandomColor() {
    return (
      "#" +
      Math.floor(Math.random() * 0x1000000)
        .toString(16)
        .padEnd(6, "0")
    );
  }

  function setColor(color) {
    editActivityColor = color;
  }

  function saveCurrentActivity() {
    let data = {
      id: editActivityId,
      activityname: editActivityName,
      color: editActivityColor,
      startEvents: startEvents.map((se) => {
        const { applicationname, clearname, ...rest } = se;
        return { ...rest, clearname: clearname || applicationname };
      }),
      endEvents: endEvents.map((ee) => {
        const { applicationname, clearname, ...rest } = ee;
        return { ...rest, clearname: clearname || applicationname };
      }),
      windowtitles: windowTitles
        .filter((window) => {
          return (
            window.activitiesList &&
            window.activitiesList.length > 0 &&
            window.activitiesList.some(
              (activity) => activity.id === editActivityId
            )
          );
        })
        .map((window) => ({
          ...window,
          windowtype: primaryWindows.includes(window.id)
            ? "primary"
            : "secondary",
        })),
      analysisid: analysisid,
    };
    if (editActivityId == 0 && editActivityName) {
      saveActivity(data);
    } else {
      updateActivity(data);
    }
  }
</script>

<Modal
  size="lg"
  open={modalOpen}
  preventCloseOnClickOutside
  modalHeading={editActivityId ? "Edit Activity" : "Add Activity"}
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    modalOpen = false;
  }}
  on:open
  on:close={() => {
    modalOpen = false;
  }}
  on:submit={() => {
    saveCurrentActivity();
    modalOpen = false;
  }}
>
  <TextInput
    labelText="Name"
    placeholder="Enter name for Activity"
    bind:value={editActivityName}
  />
  <div class="color-selection">
    <div class="button-color-selector">
      {#each listOfColors as color}
        <ButtonColorSelector
          color={color.value}
          setColor={() => setColor(color.value)}
        />
      {/each}
    </div>
    <input type="color" bind:value={editActivityColor} class="color-input" />
  </div>
</Modal>

<style>
  .color-selection {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    padding: 1rem 0.8rem 1rem 0;
    width: 100%;
    box-sizing: border-box;
  }

  .button-color-selector {
    display: inline-flex;
    gap: 0.3rem;
  }

  .color-input {
    height: 30px;
    border-radius: 5px;
    border: none;
  }

  input {
    border: none;
    padding-left: 1rem;
    width: 90%;
  }
</style>
